import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-teb-donem-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';
import { TebDonemService } from '../ctl-teb-donem.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {DlistDto} from "@dabnet-kamu/libs/ui";
@Component({
  selector: 'dk-ctl-teb-donem-arama',
  templateUrl: './ctl-teb-donem-arama.component.html',
  styleUrls: ['./ctl-teb-donem-arama.component.scss'],
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
})
export class CtlTebDonemAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private TebDonemService:TebDonemService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.TebDonemService.gridControlsList$;
    this.TebDonemService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}
